/**
 * A subscription with a scheduled "cancel after next delivery" never re-enters
 * the cancel flow (either variant): the sheet shows the banner + Cancel today
 * and hides every action that would dodge the scheduled end.
 */
export function isCancelScheduled(
  scheduledAt: string | null | undefined,
  statusLower: string,
): boolean {
  return (
    !!scheduledAt && (statusLower === "active" || statusLower === "paused")
  );
}

export interface ScheduledGateInput {
  cancelScheduled: boolean;
  canPause: boolean;
  canSkipNextOrder: boolean;
  canExtendPause: boolean;
  canChangeFrequency: boolean;
  canCancel: boolean;
}

/** Blocked-while-scheduled actions are forced off; the rest pass through. */
export function applyScheduledGate<T extends Omit<ScheduledGateInput, "cancelScheduled">>(
  cancelScheduled: boolean,
  flags: T,
): T {
  if (!cancelScheduled) return flags;
  return {
    ...flags,
    canPause: false,
    canSkipNextOrder: false,
    canExtendPause: false,
    canChangeFrequency: false,
    canCancel: false,
  };
}
